import { Datasource, IDatasource } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';
import { Comment, CommentBuilder, CommentMeta } from '../builders/comment_builder';

export interface ICommentsDatasource extends IDatasource<Comment, {}, CommentMeta> {}

angular.module('capability-ng-academic-planner').factory('ngCommentsDatasource', () =>
  new Datasource<Comment, {}, CommentMeta>({
    builderType: CommentBuilder
  }).includeMetasource<CommentMeta>((datasource) =>
    new Metasource<Comment, CommentMeta>(datasource)
      .includeAttribute('_created_ts', (comment: Comment & CommentMeta) => moment(comment.created_ts))
      .includeAttribute('_updated_ts', (comment: Comment & CommentMeta) => moment(comment.updated_ts))
  )
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/comments/datasources/comments_datasource.ts